var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    _vm._g(
      {
        staticClass: "map-control-button",
        class: {
          "map-control-button-active": _vm.active,
          "map-control-button-disabled": _vm.disabled,
        },
        style: _vm.bindStyle,
        attrs: { disabled: _vm.disabled },
      },
      _vm.$listeners
    ),
    [
      _c(
        "span",
        { staticClass: "map-control-button__content" },
        [
          _vm.loading
            ? _c("SvgIcon", {
                staticClass: "spin",
                attrs: {
                  size: (_vm.height * 2) / 3,
                  type: "mdi",
                  path: _vm.path.loading,
                },
              })
            : _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }